import { Box } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { useCurrentPreview } from '../../hooks/useCurrentPreview';
import styles from './PreviewNavDots.module.scss';
import { Preview } from './types';

const messages = defineMessages({
  previewPaginationLabelMessage: {
    defaultMessage: 'Show image {index} of {slidesLength}',
  },
});

export interface PreviewNavDotsProps {
  previews: Preview[];
  showColorConfigSeparately: boolean;
}

export const PreviewNavDots = ({
  previews,
  showColorConfigSeparately,
}: PreviewNavDotsProps) => {
  const intl = useIntl();

  const { selectedPreview, setSelectedPreview } = useCurrentPreview();

  return (
    <>
      {previews.length > 0 && selectedPreview && (
        <Box
          className={`${styles.mobileDots} ${
            showColorConfigSeparately ? styles.left : styles.center
          }`}
        >
          {previews.map((preview, index) => (
            <button
              type="button"
              key={preview.url}
              className={[
                styles.dot,
                preview.url === selectedPreview.url && styles.active,
              ]
                .filter(Boolean)
                .join(' ')}
              onClick={() => setSelectedPreview(preview)}
              title={intl.formatMessage(
                messages.previewPaginationLabelMessage,
                {
                  index: `${index + 1}`,
                  slidesLength: `${previews.length}`,
                }
              )}
              aria-label={intl.formatMessage(
                messages.previewPaginationLabelMessage,
                {
                  index: `${index + 1}`,
                  slidesLength: `${previews.length}`,
                }
              )}
            />
          ))}
        </Box>
      )}
    </>
  );
};
